import React from 'react'
import { formatAddress } from 'common/helpers'

const ClientPreview = ({ client, redirect, active }) => {
    const onClick = () => {
        redirect(client)
    }
    let className = 'card-box widget-user list-item'
    if (active)
        className += ' active'
    return (
        <div className='col-xs-12' onClick={ onClick }>
            <div className={ className }>
                <div>
                    <h4 className='m-t-0 m-b-5'>{ client.name }</h4>
                    <small className='text-custom'><b>{ formatAddress(client) }</b></small>
                    <p className='text-muted m-b-5 font-13'>Hives: { client.hives.length }</p>
                </div>
            </div>
        </div>
    )
}

export default ClientPreview


// WEBPACK FOOTER //
// ./src/client/features/client/components/ClientPreview.jsx